import { render } from "./HighchartWordCloud.vue?vue&type=template&id=5cb96dd0&ts=true"
import script from "./HighchartWordCloud.vue?vue&type=script&lang=ts"
export * from "./HighchartWordCloud.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__